import React, {useContext} from 'react';
import {ARMcontext} from '../../utils/context/context';
import {FluidContainer} from '../';
import {Left} from '../../assets/icons/icons';
import {TabContainer, TabSpan, TabWrapper} from './styles';
import Media from '../Media/Media';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  const {RemoveSelectedPlayer, selectedPlayer, selectedTeam} = useContext(ARMcontext);

  function goBack() {
    if (selectedPlayer?.name) {
      RemoveSelectedPlayer();
    } else {
      navigate('/teams/card');
    }
  }

  return (
    <TabContainer>
      <FluidContainer>
        <TabWrapper onClick={goBack} data-cy="previus-tab">
          <Left height="14px" hColor="var(--ContrastGray)" />
          {selectedPlayer?.name ? (
            <>
              <TabSpan>{selectedTeam.name + ' / '}</TabSpan>
              <Media fontSize={'14px'} size={'20px'} mRight={'5px'} imgUrl={selectedPlayer?.picture} name={selectedPlayer?.name} />
            </>
          ) : (
            <TabSpan>Back to teams</TabSpan>
          )}
        </TabWrapper>
      </FluidContainer>
    </TabContainer>
  );
};
